"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const auth_1 = require("../redux/reducers/auth");
const Portal_1 = __importDefault(require("../interface/Portal"));
const UnauthenticatedRoutes_1 = __importDefault(require("./routeSections/UnauthenticatedRoutes"));
const connector = (0, react_redux_1.connect)((state) => {
    const { auth, subscription, preCheck, isLoading } = state.auth;
    const isLoggedIn = !!auth.id;
    return {
        isLoggedIn,
        auth,
        subscription,
        preCheck,
        isLoading,
    };
}, (dispatch) => {
    return {
        getMe() {
            dispatch((0, auth_1.me)());
        },
    };
});
exports.default = connector(({ getMe, isLoggedIn, preCheck, auth, subscription, isLoading }) => {
    // useEffect(() => {
    //   if (!isLoggedIn) {
    //     getMe();
    //   }
    // }, [isLoggedIn]);
    const renderer = (Component, props) => (react_1.default.createElement(Portal_1.default, { Component, props, preCheck, auth }));
    const buildPath = (path) => {
        //TODO use environment varialbes for app.sivvl.com vs swivvl.com
        return path;
    };
    // return <Routes>{unathenticatedRoutes}</Routes>;
    return react_1.default.createElement(react_router_dom_1.Routes, null, (0, UnauthenticatedRoutes_1.default)({ renderer }));
    // return (
    //   <>
    //     {isLoggedIn ? (
    //       <Routes>
    //         {!subscription.id
    //           ? auth.enterpriserequest?.id
    //             ? AuthEnterpriseRequestRoutes({ renderer })
    //             : AuthUnsubscribedRoutes({ renderer })
    //           : AuthSubscribedRoutes({ renderer, auth })}
    //       </Routes>
    //     ) : (
    //       !isLoading &&
    //       preCheck && <Routes>{UnauthenticatedRoutes({ renderer })}</Routes>
    //     )}
    //   </>
    // );
});
